import React from "react";
import { Link } from "react-router-dom";
import { LESSONS } from "./lessons";

/**
 * «Обучение» — стартовая страница образовательного курса.
 *
 * Собрана по слайду Максима от 22.08.2026: интерактивная книга-комикс
 * с короткими видеоуроками, четыре шага от идеи до публикации.
 *
 * Раньше пункт меню вёл на демо-страницу купленной темы — список чужих
 * курсов с картинками из шаблона.
 *
 * Кнопка «Начать» пока не ведёт никуда и потому не поставлена: самих
 * уроков нет. Когда появятся, здесь встанет список глав.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

const BENEFITS = [
  {
    key: "logic",
    title: "Понятная логика создания",
    note: "Сначала объясняем, как устроен мир, и только потом просим что-то делать.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3l7 4v10l-7 4-7-4V7z" />
        <path d="M12 12l7-4M12 12v9M12 12L5 8" />
      </svg>
    ),
  },
  {
    key: "steps",
    title: "Пошаговые задания",
    note: "После каждого урока — небольшое действие, которое сразу видно в вашем мире.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="3" width="16" height="18" rx="2" />
        <path d="M8 8h8M8 12h8M8 16h5" />
      </svg>
    ),
  },
  {
    key: "location",
    title: "Своя игровая локация",
    note: "К концу курса у вас есть работающий мир, а не конспект.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21s7-5.3 7-11a7 7 0 1 0-14 0c0 5.7 7 11 7 11z" />
        <circle cx="12" cy="10" r="2.6" />
      </svg>
    ),
  },
];

const STEPS = [
  { n: 1, title: "Идея", note: "Придумываете, о чём ваш мир и кто в него придёт." },
  { n: 2, title: "Настройка", note: "Задаёте правила: квесты, награды, участники." },
  { n: 3, title: "Дизайн локации", note: "Собираете саму локацию из готовых частей." },
  { n: 4, title: "Публикация", note: "Открываете мир — в него можно заходить и играть." },
];

const LearningPage = () => (
  <div className="fw-page">
    <section className="fw-learn-hero">
      <div>
        <span className="fw-chip">Образовательный курс</span>
        <h1>Создайте свой цифровой мир</h1>
        <p>
          Интерактивная книга-комикс с короткими видеоуроками по платформе.
          От идеи — к запуску своего проекта.
        </p>
      </div>
    </section>

    <div className="fw-learn-benefits">
      {BENEFITS.map((b) => (
        <section className="fw-card fw-learn-benefit" key={b.key}>
          <span className="ic">{b.icon}</span>
          <b>{b.title}</b>
          <span className="fw-learn-note">{b.note}</span>
        </section>
      ))}
    </div>

    <div className="fw-sec-head">
      <h2>Как проходит курс</h2>
    </div>
    <p className="fw-sec-sub">Четыре шага. Каждый заканчивается тем, что видно на экране.</p>

    <div className="fw-learn-steps">
      {STEPS.map((s) => (
        <section className="fw-card fw-learn-step" key={s.n}>
          <span className="n">{s.n}</span>
          <div>
            <b>{s.title}</b>
            <span>{s.note}</span>
          </div>
        </section>
      ))}
    </div>

    <div className="fw-sec-head">
      <h2>Уроки</h2>
    </div>
    <p className="fw-sec-sub">
      Курс собирается из страниц гайд-инструкции. Первые уроки уже открыты,
      остальные добавляются по мере готовности.
    </p>

    <div className="fw-lesson-list">
      {LESSONS.map((l) => (
        <Link className="fw-card fw-lesson-item" key={l.key} to={`${PUBLIC}/learning/${l.key}`}>
          <span className="n">{l.n}</span>
          <span className="fw-lesson-item-body">
            <b>{l.title}</b>
            <span className="fw-learn-note">{l.lead}</span>
            <span className="fw-lesson-meta">{l.minutes} мин чтения</span>
          </span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 6l6 6-6 6" />
          </svg>
        </Link>
      ))}

      <section className="fw-card fw-empty">
        <b>Дальше — больше</b>
        <p>
          Следующие уроки собираем из страниц гайда: форматы заданий, создание
          задания, награды и публикация мира.
        </p>
        <Link className="fw-btn ghost" to={`${PUBLIC}/knowledge`}>
          Книга Знаний
        </Link>
      </section>
    </div>
  </div>
);

export default LearningPage;
